"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixOversetBraces = fixOversetBraces;
const tex_syntax_1 = require("./tex-syntax");
const oversetWithMissingBraces = new RegExp(`(\\\\overset${(0, tex_syntax_1.block)(3)})(\\\\${tex_syntax_1.color}(?:\\d|${(0, tex_syntax_1.block)(0)}))`, "g");
function fixOversetBraces(tex) {
    return tex.replace(oversetWithMissingBraces, "$1{$2}");
}
